module.exports = __webpack_public_path__ + "static/img/top9.c7ab824.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top9.png
// module id = cVV1
// module chunks = 208